export default __webpack_public_path__ + "static/media/AUS.4722cb60.svg";